import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { ProxyStateProvider } from './features/proxies/common/state/useProxyState';
import AuthContainer from './common/components/Containers/AuthContainer';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



root.render(
  // <React.StrictMode>
    <AuthContainer>
      <ProxyStateProvider>
        <App />
      </ProxyStateProvider>
    </AuthContainer>
  // {/* </React.StrictMode> */}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
